export { EmojiModule } from './emoji.module';
export { EmojiStoreService } from './services';
